module.exports = __webpack_public_path__ + "img/loading.7b2af8d4.gif";